define([
	'jquery',
	'pubsub',
	'promise!wcs.zmetrics'
	], function($,pubsub) {

	if(WCS_CONFIG.get('ANALYTICS::cmEnabled')) {
		$.pubsub('subscribe', 'MINICART_CONTENT_RENDER_COMPLETE', function() {
			try {
				if (typeof shopcartParams !== 'undefined') {
					shopcartParams.map(function(items) {
						cmCreateShopAction5Tag(
							items.productId,
							items.productName,		
							items.quantity,
							items.unitPrice,
							items.categoryId,
							items.extraparms
						);
						
						cmDisplayShop5s();
					});
				}
			} catch (err) {
				console.error('Failed push to coremetrics',err);
			}
		});
	}
});